// extracted by css-extract-rspack-plugin
export default {"root":"root-JLOMck","header":"header-L86CYa"};